
// 轻量运营长图页：route query 驱动（title/image），无接口无库表。
// 图片约定放 static/public/images/campaign/ 下，image 参数传相对文件名。
import { getPublicConfig, fetchPublicConfig, resolveShopShortName } from '@/utils/publicConfig'

export default {
  name: 'CampaignPage',
  data () {
    return { loadError: false, retryKey: 0 }
  },
  computed: {
    pageTitle () {
      const t = this.$route.query.title
      return (typeof t === 'string' && t.trim()) ? t.trim() : '活动详情'
    },
    posterSrc () {
      const raw = this.$route.query.image
      if (typeof raw !== 'string' || !raw.trim()) return ''
      const img = raw.trim().replace(/^\/+/, '')
      // 只允许站内 campaign 目录下的相对文件名：拒绝协议与上跳
      if (!img || img.includes('://') || img.includes('..')) return ''
      const bust = this.retryKey > 0 ? `?r=${this.retryKey}` : ''
      return `${process.env.BASE_URL}images/campaign/${img}${bust}`
    }
  },
  watch: {
    // 同页复用时 query 变化（Banner A → Banner B）须复位加载态（规则一：路由状态单路径）
    '$route.query' () {
      this.loadError = false
      this.retryKey = 0
      this.syncTitle()
    }
  },
  mounted () {
    this.syncTitle()
  },
  methods: {
    syncTitle () {
      // 运营落地页面向终端客户：标题后缀用店铺短名（简称→店铺名称，空=纯页面标题），不用系统品牌。
      // 落地页常从外链整页直进（缓存冷），异步到货后补后缀
      const cached = getPublicConfig()
      const apply = (cfg) => {
        const shop = resolveShopShortName(cfg)
        document.title = shop ? `${this.pageTitle}-${shop}` : this.pageTitle
      }
      apply(cached)
      if (!cached) fetchPublicConfig().then(apply).catch(() => {})
    },
    goBack () {
      // 移动端体验：有历史走 back（保留滚动位置），直达落地页（无历史）回首页
      if (window.history.length > 1) this.$router.back()
      else this.$router.push('/home')
    },
    retry () {
      this.retryKey++
      this.loadError = false
    }
  }
}
